module.exports = __webpack_public_path__ + "media/images/seller-guide-protecting-id-5572d54838855e0c33a2586d38f4dd80.png";